import {useEffect} from "react";
import {useForm, Controller} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {ModalForm} from "~/components";
import {InputField, GroupCheckBoxField} from "~/components/Forms";

const schema = Yup.object().shape({
	name: Yup.string().required('Vui lòng đặt tên webhook'),
	url: Yup.string()
		.required('Vui lòng nhập URL nhận sự kiện')
		.matches(/^https?:\/\//i, 'URL phải bắt đầu bằng http:// hoặc https://'),
});

/**
 * Modal tạo/sửa Webhook — name + url + chọn event đăng ký (bỏ trống = nhận TẤT CẢ).
 * `events` (taxonomy {key: nhãn}) lấy từ GET api/webhooks.
 */
function WebhookFormModal({open, title = 'Tạo webhook', submitting, defaultValues, events = {}, onCancel, onSubmit}) {

	const {control, handleSubmit, reset, formState: {errors}} = useForm({
		defaultValues: {name: '', url: '', events: [], ...defaultValues},
		resolver: yupResolver(schema),
	});

	// Nạp lại giá trị mỗi khi mở (phục vụ chế độ sửa).
	useEffect(() => {
		if (open) reset({name: '', url: '', events: [], ...defaultValues});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [open]);

	const eventOptions = Object.entries(events)
		.filter(([key]) => key !== 'test')
		.map(([value, label]) => ({value, label}));

	return (
		<ModalForm
			open={open}
			icon="fa-light fa-tower-broadcast"
			title={title}
			subtitle="Omni SEO sẽ POST sự kiện (JSON, ký HMAC) tới URL này"
			onCancel={onCancel}
			onOk={handleSubmit(onSubmit)}
			okText="Lưu webhook"
			loading={submitting}
			width={640}
		>
			<Controller control={control} name="name" render={({field}) => (
				<InputField label="Tên webhook" placeholder="VD: Slack alert server" errors={errors} {...field} />
			)} />
			<Controller control={control} name="url" render={({field}) => (
				<InputField label="URL nhận sự kiện" placeholder="https://example.com/hooks/omni-seo" errors={errors} {...field} />
			)} />
			<Controller control={control} name="events" render={({field}) => (
				<GroupCheckBoxField
					label="Sự kiện đăng ký (bỏ trống = nhận tất cả)"
					options={eventOptions}
					errors={errors}
					{...field}
				/>
			)} />
		</ModalForm>
	);
}

export default WebhookFormModal;
